"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectList;
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem/ListItem.js"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton/ListItemButton.js"));
var _react = require("react");
var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));
var _reactWindow = require("react-window");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Virtualized MUI list wrapping children in ListItemButtons. Also adds global key bindings to toggle between list items */
function SelectList({
  children,
  onSelect,
  virtualizationProps
}) {
  const [focussed, setFocussed] = (0, _react.useState)(0);
  const Row = makeRow(children, onSelect, focussed);
  const {
    itemSize = 30,
    overscanCount = 5,
    ...remainingVirtualizationProps
  } = virtualizationProps ?? {};
  (0, _react.useEffect)(() => {
    function handleKeyDown(e) {
      switch (e.code) {
        case 'Enter':
          onSelect(children[focussed]);
          e.preventDefault();
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (focussed !== children.length - 1) setFocussed(focussed + 1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (focussed !== 0) setFocussed(focussed - 1);
          break;
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [children, focussed]);
  (0, _react.useEffect)(() => {
    setFocussed(0);
  }, [children.length]);
  const listRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    listRef.current?.scrollToItem(focussed);
  }, [focussed]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    sx: {
      flex: 1
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtualizedAutoSizer.default, {
      children: ({
        height,
        width
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.FixedSizeList, {
        height: height,
        width: width,
        itemCount: children.length,
        itemSize: itemSize,
        overscanCount: overscanCount,
        ref: listRef,
        ...remainingVirtualizationProps,
        children: Row
      })
    })
  });
}
const makeRow = (rows, onSelect, focussed) => ({
  index,
  style
}) => {
  const row = rows?.[index];
  const {
    content,
    key
  } = row ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.default, {
    style: style,
    component: "div",
    disablePadding: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemButton.default, {
      onClick: () => onSelect(row),
      selected: focussed === index,
      sx: {
        height: '100%',
        p: 0
      },
      children: content
    })
  }, key);
};